declare global {
  interface Window {
    logs: string[]
  }
}

const MAX_LOGS = 500

window.logs = []

function format(args: unknown[]): string {
  return args
    .map((a) => {
      if (typeof a === 'string') return a
      if (a instanceof Error) return `${a.name}: ${a.message}\n${a.stack ?? ''}`
      try {
        return JSON.stringify(a)
      } catch {
        return String(a)
      }
    })
    .join(' ')
}

function push(level: string, message: string) {
  window.logs.push(`[${level}] ${message}`)
  if (window.logs.length > MAX_LOGS) window.logs.shift()
}

// const levels = ['log', 'info', 'warn', 'error', 'debug'] as const

const levels = ['error'] as const

for (const level of levels) {
  const original = console[level].bind(console)
  console[level] = (...args: unknown[]) => {
    push(level, format(args))
    original(...args)
  }
}

window.addEventListener('error', (event) => {
  push(
    'uncaught',
    `${event.message} @ ${event.filename}:${event.lineno}:${event.colno}`,
  )
})

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  const message =
    reason instanceof Error
      ? `${reason.name}: ${reason.message}\n${reason.stack ?? ''}`
      : format([reason])
  push('unhandledrejection', message)
})

export type WindowLogs = Window['logs']
